module.exports = __webpack_public_path__ + "static/media/bez_temp_w_domu_czuwanie_1.b6e629b4.svg";